import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum – Dickies-Campus GmbH";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream-50">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24">
        <span className="eyebrow">Rechtliches</span>
        <h1 className="mt-3 font-heading text-4xl md:text-5xl font-semibold text-sand-800 tracking-tight mb-10">Impressum</h1>

        <section className="space-y-3 text-sand-700 text-[15px] leading-relaxed">
          <p className="font-heading text-2xl text-sand-800 font-semibold">Dickies-Campus</p>
          <p>
            <strong className="text-sand-800 font-semibold">Dickies-Campus GmbH</strong><br />
            Vertreten durch die Geschäftsführerin: Linda Lüppe<br />
            Neuenhausplatz 73<br />
            40699 Erkrath<br />
            Telefon: <a href="tel:+4921129273330" className="underline hover:text-sand-800">0211 29273330</a><br />
            E-Mail: <a href="mailto:info@dickies-helden.de" className="underline hover:text-sand-800">info@dickies-helden.de</a>
          </p>

          <h2 className="font-heading text-xl text-sand-800 font-semibold mt-8 mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>Linda Lüppe, Neuenhausplatz 73, 40699 Erkrath</p>

          <h2 className="font-heading text-xl text-sand-800 font-semibold mt-8 mb-2">Redaktionell verantwortlich</h2>
          <p>
            Dickies-Campus GmbH<br />
            Neuenhausplatz 73<br />
            40699 Erkrath
          </p>

          <h2 className="font-heading text-xl text-sand-800 font-semibold mt-8 mb-2">Steuerliche &amp; Registerangaben</h2>
          <ul className="space-y-1">
            <li>Steuernummer: 147/5816/1704</li>
            <li>Handelsregister: Amtsgericht Wuppertal, HRB 33669</li>
            <li>USt-IdNr. gemäß § 27a UStG: DE360840768</li>
            <li>Betriebsnummer: 76346843</li>
          </ul>

          <h2 className="font-heading text-xl text-sand-800 font-semibold mt-8 mb-2">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

          <h2 className="font-heading text-2xl text-sand-800 font-semibold mt-10 mb-3">Haftungsausschluss (Disclaimer)</h2>

          <h3 className="font-heading text-lg text-sand-800 font-semibold mt-6 mb-2">Haftung für Inhalte</h3>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
            forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung
            der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
            diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
            möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
            entfernen.
          </p>

          <h3 className="font-heading text-lg text-sand-800 font-semibold mt-6 mb-2">Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
            verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche
            Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
            zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>

          <h3 className="font-heading text-lg text-sand-800 font-semibold mt-6 mb-2">Urheberrecht</h3>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
            auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
            Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>

          <p className="text-xs text-sand-500 mt-8">
            Quellenangaben: <a href="http://www.e-recht24.de" target="_blank" rel="noreferrer" className="underline hover:text-sand-700">www.e-recht24.de</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
